import type { AppPagination } from '@/types/pagination'

export const DEFAULT_PAGINATION: AppPagination = {
  currentPage: 1,
  perPage: 25,
}
